import React from "react";
import { Text } from "@mantine/core";
import { Display } from "@/utils/api";

export interface DisplayNameComponentProps {
  /** Display data containing the name */
  display?: Display;

  /** Additional CSS class name for styling */
  className?: string;

  /** Inline styles */
  style?: React.CSSProperties;
}

export const DisplayNameComponent: React.FC<DisplayNameComponentProps> = ({
  display,
  className,
  style,
}) => {
  // If display name exists, show it
  if (display?.name) {
    return (
      <Text
        className={className}
        style={{
          color: "inherit",
          fontSize: "inherit",
          fontWeight: "inherit",
          fontFamily: "inherit",
          lineHeight: "inherit",
          ...style,
        }}
      >
        {display.name}
      </Text>
    );
  }

  // Nothing to show
  return null;
};
